var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19853 19.1672L0.833008 13.8016V6.19883L6.19853 0.833313H13.8013L19.1668 6.19883V13.8016L13.8013 19.1672H6.19853Z",
    stroke: "#FF3D31",
    strokeWidth: 1.54,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9299 11.8017H9.06877L8.31641 4.39691H11.6822L10.9299 11.8017Z",
    fill: "#FF3D31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 15.5833C10.6229 15.5833 11.1282 15.078 11.1282 14.4547C11.1282 13.8314 10.6229 13.3262 9.99964 13.3262C9.37636 13.3262 8.87109 13.8314 8.87109 14.4547C8.87109 15.078 9.37636 15.5833 9.99964 15.5833Z",
    fill: "#FF3D31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerRed);
export default __webpack_public_path__ + "static/media/danger_red.d2b6d389.svg";
export { ForwardRef as ReactComponent };